<template>
    <div v-if="contrato && cliente">
        <status-ping :usuario="contrato.radio.username" />

        <form class="form-horizontal">
            <div class="form-group">
                <div class="col-sm-10">
                    <button
                        type="button"
                        v-if="user.level < 5 && !user.permissoes.cacontrol"
                        @click="save()"
                        class="btn btn-success"
                    >
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR
                        CONTRATO
                    </button>
                </div>
            </div>

            <div class="row" v-if="!contrato.ftth" style="margin-bottom: 20px">
                <div class="col-sm-5">
                    <button
                        type="button"
                        data-toggle="modal"
                        data-target=".toFtth"
                        class="btn btn-danger"
                    >
                        TRANSFORMAR EM FTTH
                    </button>
                </div>
            </div>

            <to-ftth @saved="saved()" :id="contrato._id"></to-ftth>

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> BASICO
                    CONTRATO
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <label for="nome" class="control-label"
                                >NOME DO CLIENTE</label
                            >
                            <input
                                id="nome"
                                disabled
                                type="text"
                                v-model="contrato.cliente.nome"
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3">
                            <label for="ip" class="control-label"
                                >IP DO CLIENTE</label
                            >
                            <div class="input-group">
                                <input
                                    id="ip"
                                    type="text"
                                    disabled
                                    class="form-control"
                                    v-model="contrato.radio.ssh.host"
                                />
                                <span class="input-group-btn">
                                    <button
                                        @click="ir()"
                                        class="btn btn-danger"
                                        type="button"
                                    >
                                        Ir!
                                    </button>
                                </span>
                            </div>
                        </div>

                        <div class="col-sm-3">
                            <label for="mac" class="control-label"
                                >MAC DO CLIENTE</label
                            >
                            <input
                                id="mac"
                                disabled
                                type="text"
                                v-model="contrato.mac"
                                class="form-control"
                            />
                        </div>

                        <div class="col-sm-3">
                            <label class="control-label">CONCENTRADOR:</label>
                            <combo-concentrador
                                :readonly="user.permissoes.cacontrol"
                                v-model="contrato.concentrador._id"
                            />
                        </div>

                        <div class="col-sm-3">
                            <label for="basico_mensal" class="control-label"
                                >MENSALIDADE</label
                            >
                            <input
                                id="basico_mensal"
                                style="text-align: right"
                                disabled
                                type="text"
                                :value="
                                    'R$ ' +
                                        (contrato.basico_mensal
                                            ? contrato.basico_mensal.toFixed(2)
                                            : 0.0)
                                "
                                class="form-control"
                            />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3">
                            <label for="tipo" class="control-label"
                                >TIPO INTERNET</label
                            >
                            <input
                                id="tipo"
                                disabled
                                type="text"
                                v-model="contrato.tipo"
                                class="form-control"
                            />
                        </div>

                        <div class="col-sm-2">
                            <label for="mb" class="control-label">MB</label>
                            <input
                                id="mb"
                                disabled
                                type="text"
                                :value="contrato.megas"
                                class="form-control"
                            />
                        </div>

                        <div class="col-sm-2">
                            <label for="cliente_desde" class="control-label"
                                >CLIENTE DESDE</label
                            >
                            <input
                                id="cliente_desde"
                                disabled
                                type="text"
                                :value="desde"
                                class="form-control"
                            />
                        </div>

                        <div
                            class="col-sm-5"
                            v-if="contrato.caixa_pacpon && !contrato.ftth"
                        >
                            <label for="pacpon" class="control-label"
                                >PAC-PON</label
                            >
                            <div class="input-group">
                                <input
                                    id="pacpon"
                                    disabled
                                    type="text"
                                    :value="contrato.caixa_pacpon.nome"
                                    class="form-control"
                                />
                                <span class="input-group-btn">
                                    <a
                                        :href="
                                            '#/caixa-pacpon/add/' +
                                                contrato.caixa_pacpon._id
                                        "
                                        class="btn btn-default btn-success"
                                        type="button"
                                        >ABRIR</a
                                    >
                                </span>
                            </div>
                        </div>

                        <div class="col-sm-5" v-if="contrato.ftth">
                            <label for="pacpon" class="control-label"
                                >PAC-PON</label
                            >
                            <div class="input-group">
                                <input
                                    id="cto"
                                    disabled
                                    type="text"
                                    :value="contrato.ftth.cto.nome"
                                    class="form-control"
                                />
                                <span class="input-group-btn">
                                    <a
                                        :href="
                                            '#/caixa-cto/add/' +
                                                contrato.ftth.cto._id
                                        "
                                        class="btn btn-default btn-success"
                                        type="button"
                                        >ABRIR</a
                                    >
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-3">
                            <label for="inputUsuario" class="control-label"
                                >USUÁRIO PPOE:</label
                            >
                            <input
                                type="text"
                                disabled
                                :value="contrato.radio.username"
                                class="form-control"
                                id="inputUsuario"
                            />
                        </div>

                        <div class="col-sm-3">
                            <label for="password" class="control-label"
                                >SENHA PPOE:</label
                            >
                            <input
                                type="text"
                                disabled
                                :value="contrato.radio.password"
                                class="form-control"
                                id="password"
                            />
                        </div>

                        <div class="col-sm-3" v-if="contrato.ftth">
                            <label for="vlan" class="control-label">VLAN:</label>
                            <input
                                type="text"
                                disabled
                                v-model="contrato.vlan"
                                class="form-control"
                                id="vlan"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <status-ftth
                :id="contrato._id"
                v-if="contrato.ftth"
                :ftth="contrato.ftth"
            ></status-ftth>

            <div class="panel panel-info">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> OBS
                </div>
                <div class="panel-body">
                    <textarea
                        :disabled="user.level >= 5"
                        v-model="contrato.obs"
                        rows="5"
                        class="form-control"
                    ></textarea>
                    <br />
                    <button
                        v-if="user.level < 5"
                        @click="saveObs()"
                        class="btn btn-default btn-success"
                        type="button"
                    >
                        SALVAR OBSERVAÇÃO
                    </button>
                </div>
            </div>

            <div class="panel panel-info" v-if="contrato.cacontrol">
                <!-- Default panel contents -->
                <div class="panel-heading">
                    <i class="fa fa-info-circle" aria-hidden="true"></i> OBS DO
                    CACONTROL
                </div>
                <div class="panel-body">
                    <textarea
                        disabled
                        v-model="contrato.cacontrol.obs"
                        rows="5"
                        class="form-control"
                    ></textarea>
                </div>
            </div>
            <div v-else>
                <h3>NENHUMA OBS DO CACONTROL!!</h3>
            </div>

            <dados-internet
                :id="contrato._id"
                v-if="user.level === 1"
                :radio="contrato.radio"
            />

            <street
                :disabled="user.level >= 5"
                :street="contrato.endereco_instalacao"
            />

            <telefones :readonly="true" :telefones="cliente.telefones" />

            <maps
                v-if="contrato.geocode.latitude"
                :nome="contrato.cliente.nome"
                :geocode="contrato.geocode"
            />

            <div class="form-group">
                <div class="col-sm-10">
                    <button
                        type="button"
                        v-if="user.level < 5 && !user.permissoes.cacontrol"
                        @click="save()"
                        class="btn btn-success"
                    >
                        <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR
                        CONTRATO
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { Contratos } from "../../../class/index";
import {
    Ssh,
    Street,
    Telefones,
    Maps,
    DadosInternet
} from "../../../components/exports";
import ComboConcentrador from "../../../components/contratos/ComboConcentrador.vue";
import StatusFtth from "../../../components/onu/StatusFtth";
import ToFtth from "../../../components/clientes/ToFtth";
import moment from "moment";

/* global swal */
export default {
    components: {
        Ssh,
        Street,
        Telefones,
        StatusFtth,
        ToFtth,
        ComboConcentrador,
        Maps,
        DadosInternet
    },
    data() {
        return {
            user: null
        };
    },
    computed: {
        contrato() {
            return this.$store.state.contrato;
        },
        cliente() {
            return this.$store.state.cliente;
        },
        desde() {
            return moment(this.contrato.cliente_desde).format("DD/MM/YYYY");
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        save() {
            Contratos.save(this.contrato)
                .then(() => this.$router.push({ path: "/contratos" }))
                .catch(err => console.log(err));
        },

        saved() {
            Contratos
                .byID(this.contrato._id)
                .then(row => {
                    this.$store.commit("setContrato", row);
                })
                .catch(err => console.error(err));
        },

        onIP(ip) {
            this.contrato.radio.ssh.host = ip;
        },

        saveObs() {
            let json = {
                _id: this.contrato._id,
                obs: this.contrato.obs
            };

            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar a OBS do contrato?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => Contratos.updateObs(json)
                }
            ]);
        },

        ir() {
            window.open(
                "http://" + this.contrato.radio.ssh.host + ":8080",
                "__blank"
            );
        }
    }
};

//{"_id":"5a3d9910b5c2f46e8fb2b32d","ref_id":7140,"radio":{"config_burst":{"enable":false,"valor_minimo":30,"valor_maximo":100},"limit_dedicado":50,"prioridade":8,"auth_only_usuario":true,"internet_dedicada":false,"burst":false,"ssh":{"algorithms":{"serverHostKey":["ssh-rsa","ssh-dss"]},"readyTimeout":5000,"username":"anderson","password":"master102030","host":"100.64.7.163"},"username":"anderson","password":"master102030","upload":51200,"download":51200,"ip":"100.64.7.163"},"geocode":{"latitude":-21.759196,"longitude":-41.3347426},"tipo":"FIBRA","active":true,"bloqueado":false,"porta_inicial":10016,"porta_final":10030,"data_boleto_bloqueio":null,"instalado":true,"endereco_instalacao":{"cep":"28035-053","bairro":"PARQUE TAMANDARÉ","cidade":"CAMPOS DOS GOYTACAZES","estado":"RJ","numero":"245","endereco":"AVENIDA PELINCA","complemento":"BL:2 APT:302"},"config_id":"596e43e26b34cd73b1216be5","cliente":{"_id":"594d2702f85b4bc0d568497e","nome":"WALLACE SILVA"},"concentrador_id":"594d5e63f85b4bc0d56849ec","created_at":"2017-12-22T23:45:20.698Z","count_ping_off":0,"disable_icinga":false,"last_ping_off":"2019-03-26T16:32:06.061Z","last_auth_radius":"2019-02-26T13:05:26.613Z","last_ping_on":"2019-02-26T13:02:03.525Z","updated_at":"2019-07-26T18:43:53.266Z","concentrador":{"_id":"5bd1c917a7760e001b4e4611","nome":"CONC. 1036"},"empresa":{"_id":"596e43e26b34cd73b1216be5","nome":"Center Alarm"},"place":[-41.3347426,-21.759196],"hotspot":{"usuario":"centersat9","prefix":9,"senhas":[{"_id":"5c6e9cc23aa35f001e78e059","senha":"16317net9","mac":"A8:16:D0:58:A0:7D"},{"_id":"5c6e9e4b3aa35f001e78e3d7","senha":"55966net9","mac":"08:C5:E1:92:0B:F8"}]},"mac":"B0:4E:26:09:6E:C3","basico_mensal":0,"megas":50,"cliente_desde":"2017-04-25T00:00:00.000Z","obs_ipv6":null,"last_ipv6":"2804:51dc:124:6400::/56","caixa_cto":{"_id":"5aa568d8b53bd96dc01dfd0b","numero":4,"nome":"CTO-4"},"caixa_pacpon":{"_id":"5ab95264dbdcf9473e58c79b","numero":56,"nome":"CTO-4 PAC-56"},"caixa_switch":null,"cacontrol":{"obs":null},"sessao_online":{"online":true,"last_online":"2019-07-26T18:43:53.000Z","last_offline":"2019-07-24T19:14:42.000Z"},"ip_fixo":false,"ftth":{"cto":{"_id":"5d39dd6b5cbd1d001f025672","numero":87,"nome":"CTO-87"},"onu_mac":"ZNTS3fe452971234567890MARVELL123","ponid":"na-na-2-5","vlan":"2001","numero":100}}
</script>
